export const FORGOT_PASSWORD = 'Forgot password';
export const FORGOT_PASSWORD_SUCCESS = 'Forgot password success';
export const FORGOT_PASSWORD_ERROR = 'Forgot password error';

export const RESET_PASSWORD = 'Reset password';
export const RESET_PASSWORD_SUCCESS = 'Reset password success';
export const RESET_PASSWORD_ERROR = 'Reset password error';

export const FORGOT_USERNAME = 'Forgot username';
export const FORGOT_USERNAME_SUCCESS = 'Forgot username success';
export const FORGOT_USERNAME_ERROR = 'Forgot username error';

export const forgotPassword = (email) => ({
  type: FORGOT_PASSWORD,
  payload: { email },
});

export const forgotPasswordSuccess = (payload) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload,
});

export const forgotPasswordError = (payload) => ({
  type: FORGOT_PASSWORD_ERROR,
  payload,
});

export const resetPassword = ({ uid, token, newPassword }) => ({
  type: RESET_PASSWORD,
  payload: { uid, token, newPassword },
});

export const resetPasswordSuccess = (payload) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload,
});

export const resetPasswordError = (payload) => ({
  type: RESET_PASSWORD_ERROR,
  payload,
});

export const forgotUsername = (email) => ({
  type: FORGOT_USERNAME,
  payload: { email },
});

export const forgotUsernameSuccess = (payload) => ({
  type: FORGOT_USERNAME_SUCCESS,
  payload,
});

export const forgotUsernameError = (payload) => ({
  type: FORGOT_USERNAME_ERROR,
  payload,
});
